exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3PdcYVtRuHTlvL{font-weight:400;margin:0}._1h9PvS3YBMEHS9{font-weight:700;color:#5e6c84;font-size:12px;line-height:16px;margin-top:12px;margin-bottom:4px;display:block;margin-bottom:12px}._3RR1FYJnGwUrS_ .autocomplete-input-container{max-width:none}._3RR1FYJnGwUrS_ .autocomplete-btn{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"teamMemberLabel": "_3PdcYVtRuHTlvL",
	"teamMemberLabelText": "_1h9PvS3YBMEHS9",
	"container": "_3RR1FYJnGwUrS_"
};